<template>
  <v-main class="pt-12 text-right">
    <v-btn
        x-large
        rounded
        color="secondary"
        dark
        to="/applications/create"
        class="mt-4"
    >
      <v-icon left>mdi-account-multiple-plus</v-icon>
      Submit New Application
    </v-btn>
    <v-sheet class="mt-3 pa-4 primary lighten-1">
      <v-text-field
          v-model="query"
          label="Search application by number, option or main applicant name"
          dark
          flat
          solo-inverted
          hide-details
          clearable
          clear-icon="mdi-close"
      >
      </v-text-field>
    </v-sheet>
    <applications-filter v-if="isAdmin" :filter.sync="filters"></applications-filter>
    <v-data-table
        :headers="headers"
        :items="applications"
        :server-items-length="totalApplications"
        :loading="loading"
        :options.sync="options"
        :footer-props="{
                    itemsPerPageOptions: [5, 10, 15, 30, -1]
                }"
        v-model="selected"
        must-sort
        class="elevation-1 mt-2"
    >
      <template v-slot:[`item.status`]="{ item }">
        <span v-if="status(item)" class="d-inline-block"><v-icon :color="status(item)">{{
            statusIcon(item)
          }}</v-icon></span>
      </template>
      <template v-slot:[`item.number`]="{ item }">
        <router-link :to="{ name: 'ApplicationView', params: { id: item.id }}" tag="a">{{ item.number }}</router-link>
      </template>
      <template v-slot:[`item.option`]="{ item }">
        {{ item.option_name }}
      </template>
      <template v-slot:[`item.total_applicants`]="{ item }">
        {{ item.total_applicants - 1 }}
      </template>
      <template v-slot:[`item.current_step`]="{ item }">
            <span :class="item.progress[item.current_step-1].error ? 'error--text' : 'success--text'">
              {{ item.progress[item.current_step - 1].name }}
            </span>
      </template>
      <template v-slot:[`item.manager`]="{ item }">
        {{ item.manager_fullname }}
      </template>
      <template v-slot:[`item.created`]="{ item }">
        {{ item.created | formatISO }}
      </template>
      <template v-slot:[`item.updated`]="{ item }">
        {{ item.updated | formatISO }}
      </template>
    </v-data-table>
  </v-main>
</template>
<script>
import debounce from 'lodash.debounce'
import moment from 'moment'
import {mapGetters} from 'vuex'
import ApplicationsFilter from './AdminListFilter'
import {errorNotification} from "@/components/utils";

export default {
  components: {ApplicationsFilter},
  name: 'ApplicationsList',
  data() {
    return {
      applications: [],
      selected: [],
      totalApplications: 0,
      // query: '',
      // options: {
      //     page: 1,
      //     itemsPerPage: 10,
      //     sortBy: [
      //         'created'
      //     ],
      //     sortDesc: [
      //         'created'
      //     ]
      // },
      // filters: {},
      // TODO: Look for better solution to avoid direct calls to store here
      query: this.$store.getters['search/applications']['query'],
      options: this.$store.getters['search/applications']['options'],
      filters: this.$store.getters['search/applications']['filters'],
      loading: false
    }
  },
  computed: {
    ...mapGetters('auth', [
      'isAdmin'
    ]),
    headers() {
      let headers = []
      if (this.isAdmin) {
        headers = [
          {text: '', value: 'status', align: 'center', sortable: false},
          {text: 'Number', value: 'number', align: 'left', sortable: true},
          {text: 'Option', value: 'option', align: 'center', sortable: true},
          {text: 'Main Applicant', value: 'main_applicant', align: 'center', sortable: true},
          {text: 'Dependants', value: 'total_applicants', align: 'center', sortable: true},
          {text: 'Current Step', value: 'current_step', align: 'center', sortable: true},
          {text: 'Added by', value: 'agent', align: 'center', sortable: true},
          {text: 'Manager', value: 'manager', align: 'center', sortable: true},
          {text: 'Created Date', value: 'created', align: 'center', sortable: true},
          {text: 'Updated Date', value: 'updated', align: 'center', sortable: true}
        ]
      } else {
        headers = [
          {text: '', value: 'status', align: 'center', sortable: false},
          {text: 'Number', value: 'number', align: 'left', sortable: true},
          {text: 'Option', value: 'option', align: 'center', sortable: true},
          {text: 'Main Applicant', value: 'main_applicant', align: 'center', sortable: true},
          {text: 'Dependants', value: 'total_applicants', align: 'center', sortable: true},
          {text: 'Current Step', value: 'current_step', align: 'center', sortable: true},
          {text: 'Added by', value: 'agent', align: 'center', sortable: true},
          {text: 'Manager', value: 'manager', align: 'center', sortable: true},
          {text: 'Created Date', value: 'created', align: 'center', sortable: true},
          {text: 'Updated Date', value: 'updated', align: 'center', sortable: true}
        ]
      }

      return headers
    }
  },
  filters: {
    formatISO(date) {
      return moment(date).format('YYYY-MM-DD')
    },
    formatFromNow(date) {
      return moment(date).fromNow()
    }
  },
  watch: {
    query() {
      this.options['page'] = 1
      this.search()
    },
    filters: {
      handler() {
        this.options['page'] = 1
        this.search()
      },
      deep: true
    },
    options: {
      handler() {
        this.search()
      },
      deep: true
    }
  },
  methods: {
    fetchData() {
      this.loading = true

      const {sortBy, sortDesc, page, itemsPerPage} = this.options

      let searchParams = {
        search: this.query,
        page_size: itemsPerPage,
        page: page,
        ordering: sortBy[0] ? (sortDesc[0] ? '-' : '') + sortBy : null
      }

      searchParams = Object.assign(searchParams, this.filters)

      return new Promise((resolve, reject) => {
        this.$axios.get('/applications/', {
          params: searchParams
        })
            .then((response) => {
              let items = []
              let total = 0
              if (response.data.results) {
                items = response.data.results
                total = response.data.count
              } else {
                items = response.data
                total = items.length
              }
              this.loading = false
              resolve({
                items,
                total
              })
            })
            .catch((e) => {
              this.loading = false
              reject(e)
            })
      })
    },
    search: debounce(
        function () {
          this.fetchData()
              .then(data => {
                this.applications = data.items
                this.totalApplications = data.total
              })
              .catch((error) => {
                errorNotification(error)
              })
          this.$store.dispatch('search/save', {
            component: 'applications',
            params: {
              query: this.query,
              filters: this.filters,
              options: this.options
            }
          })
        },
        600),
    status(item) {
      if (item.is_complete && !item.is_declined) {
        return 'success'
      }
      if (item.is_declined) {
        return 'error'
      }
      if (item.is_withdrawn) {
        return 'warning'
      }
      return false
    },
    statusIcon(item) {
      if (item.is_complete && !item.is_declined) {
        return 'mdi-account-check'
      }
      if (item.is_declined) {
        return 'mdi-account-cancel'
      }
      if (item.is_withdrawn) {
        return 'mdi-account-remove'
      }
      return false
    }

  },
  mounted() {
    this.$nextTick(() => {
      if (this.isAdmin && !('manager' in this.filters)) {
        this.$set(this.filters, 'manager', this.$store.state.auth.user.id)
      }
      // this.search()
    })
  }
}
</script>